import { createContext, useContext } from 'react';

type BigRockContextType = {
  /**
   * Controls enabling an alpha-level redesign of the grid itself -
   * please don't use in production.
   */
  bigRocked: boolean;
};

const BigRockContext = createContext<BigRockContextType>({
  bigRocked: false,
});

export const BigRockProvider = BigRockContext.Provider;

/**
 * Checks if the big rock feature is enabled.
 */
export function useIsBigRockEnabled() {
  const { bigRocked } = useContext(BigRockContext);
  return bigRocked;
}
